import { useEffect } from 'react';
import classNames from 'classnames';
import Script from 'next/script';
import { useGlobalModules } from 'contexts';
import styles from './rating.module.scss';

const Rating = ({ SKU, locale, className }) => {
  const { translations } = useGlobalModules() || {};
  const settings = {
    store: 'keune.com',
    mode: 'default',
    color: '#0E1311',
    linebreak: false,
    text: '',
    singularText: '',
    lang: locale,
    usePolaris: false,
    showEmptyStars: false,
    writeSchemaOrg: false,
  };

  useEffect(() => {
    if (SKU && window.ratingSnippet) {
      window.ratingSnippet('ruk_rating_snippet', settings);
    }
  }, [SKU, locale]); // Re-run when SKU or locale changes

  if (!SKU) return null;

  return (
    <a href="#ReviewsWidget" aria-label={translations?.accessibility?.readReviews || 'Read reviews'} className={classNames(styles.container, className)}>
      <div key={`${SKU}-${locale}`} className="ruk_rating_snippet" data-sku={SKU} />
      <Script
        type="text/javascript"
        strategy="afterInteractive"
        onLoad={() => {
          // Initial load
          if (typeof window !== 'undefined' && window.ratingSnippet) {
            try {
              window.ratingSnippet('ruk_rating_snippet', settings);
            } catch (e) {
              console.error('Error executing ratingSnippet:', e);
            }
          }
        }}
      >
        {`try{ratingSnippet("ruk_rating_snippet",${JSON.stringify(
          settings
        )});}catch(e){console.error('Error executing ratingSnippet:', e);}`}
      </Script>
    </a>
  );
};

export default Rating;
